export default "__VITE_ASSET__Dkb3RCVD__"